<template>
  <div>
    <el-row style="margin-top:30px">
      <el-col>
        <el-form :inline="true" class="demo-form-inline" :model="searchForm" :ref="searchForm" style="margin: 0">
          <el-col :xl="5" :lg="8" :md="12">
            <el-form-item label="产品名称：">
              <el-input size="medium" placeholder="产品名称" v-model="searchForm.LKD_PRODUCT_NAME" clearable
                @keyup.enter.native="filtrate()"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xl="5" :lg="8" :md="12">
            <el-form-item label="产品编码：">
              <el-input size="medium" placeholder="产品编码" v-model="searchForm.LKD_PRODUCT_CODE" clearable
                @keyup.enter.native="filtrate()"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xl="5" :lg="8" :md="12">
            <el-form-item label="自定义产品名称：">
              <el-input size="medium" placeholder="自定义产品名称" v-model="searchForm.TC_PRODUCT_NAME" clearable
                @keyup.enter.native="filtrate()"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xl="5" :lg="8" :md="12">
            <el-form-item label="自定义编码：">
              <el-input size="medium" placeholder="自定义编码" v-model="searchForm.TC_PRODUCT_CODE" clearable
                @keyup.enter.native="filtrate()"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xl="{ span: 1, offset: 1 }" :lg="1" :md="1">
            <el-button size="medium" type="primary" @click="filtrate()" :loading="loading">筛选</el-button>
          </el-col>
          <el-col style="margin-top: 20px;margin-bottom: 20px">
            <el-button size="medium" @click="addMatch">新增匹配</el-button>
            <el-button size="medium" @click="exportEnter">导入</el-button>
            <el-button size="medium" @click="客户编码导出()">自定义编码导出</el-button>
            <tooltip-button :disabled="Boolean(CUSTOMER_CODE_IDS[0])" tipContent="请先勾选订单" buttonType="primary"
              buttonPlain buttonText="批量解除编码关系" @click="批量解除编码关系()">
            </tooltip-button>

          </el-col>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <p style="color: red">换算比例：客户是一个单位，换成系统的是多少</p>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table stripe border :data="tableData" @selection-change="(e) => 批量解除勾选(e)">
          <el-table-column type="selection" width="40"></el-table-column>
          <el-table-column label="序号" type="index" width="50"></el-table-column>
          <el-table-column label="产品编码" prop="LKD_PRODUCT_CODE"></el-table-column>
          <el-table-column label="自定义编码" prop="TC_PRODUCT_CODE"></el-table-column>
          <el-table-column label="换算比例" prop="CHANGE_RATE"></el-table-column>
          <el-table-column label="产品名称" prop="NAME"></el-table-column>
          <el-table-column label="自定义产品名称" prop="TC_PRODUCT_NAME"></el-table-column>
          <el-table-column label="单位" prop="TYPE_UNIT"></el-table-column>
          <el-table-column label="客户单位" prop="TC_PRODUCT_UNIT"></el-table-column>
          <el-table-column label="操作" min-width="130">
            <template slot-scope="scope">
              <el-button type="text" size="small" icon="el-icon-view" @click="deleteMatch(scope.row)">解除匹配</el-button>
              <el-button type="text" size="small" icon="el-icon-view" @click="openEdit(scope.row)">修改</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <el-col :span="24" style="text-align: right">
        <el-pagination @current-change="handleChange" :current-page.sync="currentPage" :page-size="pageSize"
          layout="total,prev, pager, next, jumper" :total="totalCount"></el-pagination>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-dialog title="修改" center :visible.sync="editFormVisible" width="500px">
          <el-form :model="editForm" ref="editForm" style="margin-top: 0">
            <el-form-item label="产品编码：" :label-width="formLabelWidth" prop="leader">
              <el-input v-model="editForm.LKD_PRODUCT_CODE"></el-input>
            </el-form-item>
            <el-form-item label="自定义产品名称：" :label-width="formLabelWidth" prop="leader">
              <el-input v-model="editForm.TC_PRODUCT_NAME"></el-input>
            </el-form-item>
            <el-form-item label="自定义编码：" :label-width="formLabelWidth" prop="leader">
              <el-input v-model="editForm.TC_PRODUCT_CODE"></el-input>
            </el-form-item>
            <el-form-item label="客户单位：" :label-width="formLabelWidth" prop="leader">
              <el-input v-model="editForm.TC_PRODUCT_UNIT"></el-input>
            </el-form-item>
            <el-form-item label="换算比例：" :label-width="formLabelWidth" prop="leader">
              <el-input v-model="editForm.CHANGE_RATE"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="close('editForm')">取 消</el-button>
            <el-button v-if="actionFlag == 0" @click="submitAdd('editForm')">确 定</el-button>
            <el-button v-else @click="submitEdit('editForm')">确 定</el-button>
          </div>
        </el-dialog>
      </el-col>
    </el-row>
    <!-- 导入订单 -->
    <el-dialog :visible.sync="exportOrderDialog" title="导入订单" width="400px" center>
      <el-form ref="orderForm" v-model="orderForm">
        <el-upload class="upload-demo" action="/uploadFile" ref="upload" :on-remove="handleRemove"
          :on-success="handleSuccess" :name="this.orderForm.orderName" multiple :limit="1" accept=".xls,.xlsx"
          :file-list="fileList">
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">只能上传xls/xlsx文件，且不超过500kb</div>
        </el-upload>
        <p @click="downLoadOrder" style="color: #409EFF;margin-top: 20px;cursor: pointer">点击下载导入模板</p>
      </el-form>
      <div slot="footer" style="text-align: center;">
        <el-button class="operate-btn" @click="exportOrderDialog = false">取消</el-button>
        <el-button class="operate-btn" @click="handleExportOrder">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  tcCodeManage, matchCode, deleteMatch, editCode, exportMatchCode,
} from 'api/customerManage';
import http from '@/assets/common/http';
import util from '@/assets/common/util';

export default {
  data() {
    return {
      CUSTOMER_CODE_IDS: [], // 批量解除所勾选的数组
      searchForm: {},
      loading: false,
      tableData: [],
      totalCount: 0,
      currentPage: 1,
      pageSize: 20,
      editForm: {},
      editFormVisible: false,
      formLabelWidth: '120px',
      actionFlag: 0,
      exportOrderDialog: false,
      orderForm: {
        orderName: 'tmp',
      },
      fileList: [],
      file_name: '',
    };
  },
  methods: {
    // -----------------------------筛选
    filtrate() {
      this.currentPage = 1;
      this.queryTable();
    },
    批量解除勾选(e) {
      this.CUSTOMER_CODE_IDS = e.map(({ ID }) => ID);
    },
    queryTable() {
      const params = {
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
        TC_ID: sessionStorage.getItem('customerId'),
      };
      if (this.searchForm.LKD_PRODUCT_NAME) {
        params.LKD_PRODUCT_NAME = this.searchForm.LKD_PRODUCT_NAME;
      }
      if (this.searchForm.LKD_PRODUCT_CODE) {
        params.LKD_PRODUCT_CODE = this.searchForm.LKD_PRODUCT_CODE;
      }
      if (this.searchForm.TC_PRODUCT_NAME) {
        params.TC_PRODUCT_NAME = this.searchForm.TC_PRODUCT_NAME;
      }
      if (this.searchForm.TC_PRODUCT_CODE) {
        params.TC_PRODUCT_CODE = this.searchForm.TC_PRODUCT_CODE;
      }
      tcCodeManage(params)
        .then((res) => {
          if (res.length !== 0) {
            this.tableData = res[0].list;
            this.totalCount = res[0].TOTAL_COUNT;
          } else {
            this.tableData = [];
          }
          this.loading1 = false;
        }).catch((err) => {
          this.loading1 = false;
          this.$message.show({ text: err, type: 'error' });
        });
    },
    handleChange(e) {
      this.currentPage = e;
      this.queryTable();
    },
    addMatch() {
      this.editForm = {};
      this.editFormVisible = true;
      this.actionFlag = 0;
    },
    submitAdd() {
      const reg = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/;
      if (!reg.test(this.editForm.LKD_PRODUCT_CODE)) {
        this.$message.show({ text: '请输入正确产品编码', type: 'warning' });
        return false;
      }
      if (!reg.test(this.editForm.TC_PRODUCT_CODE)) {
        this.$message.show({ text: '请输入正确自定义编码', type: 'warning' });
        return false;
      }
      if (!reg.test(this.editForm.CHANGE_RATE)) {
        this.$message.show({ text: '请输入正确换算比例', type: 'warning' });
        return false;
      }
      const params = {
        TC_ID: sessionStorage.getItem('customerId'),
        LKD_PRODUCT_CODE: this.editForm.LKD_PRODUCT_CODE,
        TC_PRODUCT_CODE: this.editForm.TC_PRODUCT_CODE,
        TC_PRODUCT_NAME: this.editForm.TC_PRODUCT_NAME,
        TC_PRODUCT_UNIT: this.editForm.TC_PRODUCT_UNIT,
        CHANGE_RATE: this.editForm.CHANGE_RATE,
      };
      if (!this.editForm.TC_PRODUCT_NAME || !this.editForm.TC_PRODUCT_UNIT) {
        this.$message.show({ text: '请输入自定义产品名称和单位', type: 'warning' });
        return false;
      }
      matchCode(params)
        .then((res) => {
          this.$message.show({ text: '新增成功', type: 'success' });
          this.editFormVisible = false;
          this.queryTable();
        }).catch((err) => {
          this.loading1 = false;
          this.$message.show({ text: err, type: 'error' });
        });
    },
    deleteMatch(row) {
      const params = {
        TC_ID: sessionStorage.getItem('customerId'),
        RELEATION_ID: row.ID,
      };
      deleteMatch(params)
        .then((res) => {
          this.$message.show({ text: '操作成功', type: 'success' });
          this.queryTable();
        }).catch((err) => {
          this.loading1 = false;
          this.$message.show({ text: err, type: 'error' });
        });
    },
    openEdit(row) {
      this.editFormVisible = true;
      this.editForm = row;
      this.actionFlag = 1;
    },
    submitEdit() {
      const reg = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/;
      if (!reg.test(this.editForm.LKD_PRODUCT_CODE)) {
        this.$message.show({ text: '请输入正确产品编码', type: 'warning' });
        return false;
      }
      if (!reg.test(this.editForm.TC_PRODUCT_CODE)) {
        this.$message.show({ text: '请输入正确自定义编码', type: 'warning' });
        return false;
      }
      if (!reg.test(this.editForm.CHANGE_RATE)) {
        this.$message.show({ text: '请输入正确换算比例', type: 'warning' });
        return false;
      }
      const params = {
        TC_ID: sessionStorage.getItem('customerId'),
        RELEATION_ID: this.editForm.ID,
        LKD_PRODUCT_CODE: this.editForm.LKD_PRODUCT_CODE,
        TC_PRODUCT_CODE: this.editForm.TC_PRODUCT_CODE,
        TC_PRODUCT_NAME: this.editForm.TC_PRODUCT_NAME,
        TC_PRODUCT_UNIT: this.editForm.TC_PRODUCT_UNIT,
        CHANGE_RATE: this.editForm.CHANGE_RATE,
      };
      if (!this.editForm.TC_PRODUCT_NAME || !this.editForm.TC_PRODUCT_UNIT) {
        this.$message.show({ text: '请输入自定义产品名称和单位', type: 'warning' });
        return false;
      }
      editCode(params).then((res) => {
        this.$message.show({ text: '修改成功', type: 'success' });
        this.editFormVisible = false;
        this.queryTable();
      }).catch((err) => {
        this.loading1 = false;
        this.$message.show({ text: err, type: 'error' });
      });
    },
    // 导入订单
    exportEnter() {
      this.exportOrderDialog = true;
    },
    批量解除编码关系() {
      const params = {
        SERVICE_ID: '10203',
        OTYPE: 8,
        TC_ID: sessionStorage.getItem('customerId'),
        CUSTOMER_CODE_IDS: this.CUSTOMER_CODE_IDS,
      };
      http.post(params).then((res) => {
        this.$message.show({ text: '解除关系成功', type: 'success' });
        this.queryTable();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    客户编码导出() {
      const params = {
        SERVICE_ID: '10203',
        OTYPE: 7,
        PAGESIZE: 99999999,
        PAGEINDEX: 0,
        TC_ID: sessionStorage.getItem('customerId'),
      };
      if (this.searchForm.LKD_PRODUCT_NAME) {
        params.LKD_PRODUCT_NAME = this.searchForm.LKD_PRODUCT_NAME;
      }
      if (this.searchForm.LKD_PRODUCT_CODE) {
        params.LKD_PRODUCT_CODE = this.searchForm.LKD_PRODUCT_CODE;
      }
      if (this.searchForm.TC_PRODUCT_NAME) {
        params.TC_PRODUCT_NAME = this.searchForm.TC_PRODUCT_NAME;
      }
      if (this.searchForm.TC_PRODUCT_CODE) {
        params.TC_PRODUCT_CODE = this.searchForm.TC_PRODUCT_CODE;
      }
      http.post(params).then((res) => {
        if (res[0]) {
          window.location.href = util.getURLLocalHost(res[0].FILE_PATH);
        } else {
          this.$message.show({ text: '暂无数据', type: 'success' });
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    handleSuccess(response, file, fileList) {
      this.file_name = response.file_name;
    },
    handleRemove(file, fileList) {
      this.fileList = [];
      this.file_name = '';
    },
    handleExportOrder() {
      const params = {
        TC_ID: sessionStorage.getItem('customerId'),
        FILE_NAME: this.file_name,
      };
      if (!this.file_name) {
        this.$message.show({ text: '请先上传文件', type: 'warning' });
        return false;
      }
      exportMatchCode(params).then((result) => {
        if (result[0].FILE_PATH == '') {
          this.$message.show({ text: '导入成功', type: 'success' });
          this.file_name = '';
          this.$refs.upload.clearFiles();
          this.exportOrderDialog = false;
          this.queryTable();
        } else {
          this.$message.show({ text: '导入失败，失败原因查看EXCEL', type: 'error' });
          this.file_name = '';
          this.$refs.upload.clearFiles();
          window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
        this.file_name = '';
        this.$refs.upload.clearFiles();
      });
    },
    downLoadOrder() {
      window.location.href = 'https://service.linkda.com.cn/file/templates/tcProductsCodetemp.xls';
    },
    close() {
      this.editFormVisible = false;
    },
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (this.SAVE_DSORDER_LIST) {
      this.searchForm = this.SAVE_DSORDER_LIST.CONDITION;
      this.currentPage = this.SAVE_DSORDER_LIST.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    this.queryTable();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/customerManage/tcCodeManage.vue